import React from "react";
import "./Solution.css";

const Solutions = () => {
  return (
    <section className="solutions">
      <h2 className="solutions-title">Solutions for Every Team</h2>
      <p className="solutions-subtitle">
        From enterprises to growing startups and recruitment agencies, our
        platform empowers every team with the right tools to hire, plan, and
        grow efficiently.
      </p>

      <div className="solutions-cards">
        {/* Card 1 */}
        <div className="solution-card enterprise">
          <h3 className="card-title">Enterprise</h3>
          <p>
            Scalable solutions to support large organizations with complex
            hiring needs.
          </p>
          <ul>
            <li>Centralized hiring management</li>
            <li>Advanced analytics & reporting</li>
            <li>Seamless integration with HR systems</li>
          </ul>
          <button>Learn More</button>
        </div>

        {/* Card 2 */}
        <div className="solution-card tech">
          <h3 className="card-title">Tech Companies</h3>
          <p>
            Tailored recruitment workflows designed for fast-growing technology
            teams.
          </p>
          <ul>
            <li>AI-driven candidate matching</li>
            <li>Collaborative hiring tools</li>
            <li>Flexible job posting options</li>
          </ul>
          <button>Learn More</button>
        </div>

        {/* Card 3 */}
        <div className="solution-card agencies">
          <h3 className="card-title">Agencies</h3>
          <p>
            Streamline client hiring processes and place candidates more
            efficiently.
          </p>
          <ul>
            <li>Multi-client recruitment dashboards</li>
            <li>Customizable workflows</li>
            <li>Built-in communication tools</li>
          </ul>
          <button>Learn More</button>
        </div>
      </div>
    </section>
  );
};

export default Solutions;
